import React from 'react';
import { connect } from 'react-redux';
import Dropzone from 'react-dropzone';
import { List } from 'immutable';
import {
  Modal,
  Col,
  Row,
  Panel,
} from 'react-bootstrap';
import {
  FormControl,
  Button,
} from '../../../form/FormControls.jsx';
import Label from '@/component/form/Label.jsx';
import { addFile, updateFile, deleteFile } from '../store/files.store';
import { handleFormChanged } from '@/store/allaround.store.js';
import trash from '../../../../../style/trash.png';
import pencil from '../../../../../style/pencil.png';

class Files extends React.Component {
  constructor(props) {
    super(props);
    this.close = this.close.bind(this);
    this.open = this.open.bind(this);
    this.onDrop = this.onDrop.bind(this);
    this.onSave = this.onSave.bind(this);
    this.removeFile = this.removeFile.bind(this);
    this.openFileEdit = this.openFileEdit.bind(this);
    this.onEdit = this.onEdit.bind(this);
    this.changeRegNumber = this.onChange.bind(this, 'regNumber');
    this.closeDeleteModal = this.closeDeleteModal.bind(this);
    this.openDeleteModal = this.openDeleteModal.bind(this);
    this.addFile = this.addFile.bind(this);
    this.dropzone = this.dropzone.bind(this);
    this.renderUI = this.renderUI.bind(this);
    this.deleteConfirmation = this.deleteConfirmation.bind(this);
    this.editInline = this.editInline.bind(this);
    this.state = { editMode: false, showModal: false,
      currentFile: undefined, meta: {}, fileDeleteConfirmation: null };
  }

  componentWillReceiveProps(props) {
    if (props.editMode) {
      this.setState({ editMode: true, showModal: true,
        meta: props.data.meta, currentFile: props.data });
    } else {
      this.setState({ editMode: false, showModal: false });
    }
  }

  componentWillUpdate(props, state) {
    if (this.props.onEditModeSwitch && this.state.editMode != state.editMode) {
      this.props.onEditModeSwitch(state.editMode);
    }
  }

  onDrop(files) {
    const newState = { currentFile: files[0], meta: {} };
    this.setState(newState);
    if (this.props.noModal) {
      this.onSave(newState);
    }
  }

  onSave(newState = this.state) {
    if (newState.currentFile) {
      const newMeta = Object.assign({ type: this.props.type }, newState.meta);
      this.addFile({ file: newState.currentFile, meta: newMeta });
      this.setState({ showModal: false, editMode: false,
        currentFile: undefined, meta: {} });
    }
    this.props.handleFormChanged();
  }

  onChange(field, evt) {
    this.setState({ meta: { [field]: evt.target.value } });
  }

  onEdit() {
    const changedFile = this.state.currentFile.get('raw');
    const newMeta = Object.assign(changedFile.meta, this.state.meta);
    changedFile.meta = newMeta;
    const idx = this.props.files.indexOf(this.state.currentFile);
    this.props.updateFile(changedFile, idx);
    this.setState({ showModal: false, editMode: false,
      currentFile: undefined, meta: {} });
    this.props.handleFormChanged();
  }

  getLabel(f) {
    let label = '';
    if (f.meta && f.meta.originalName) {
      label = f.meta.originalName;
    } else if (f.file && f.file.name) {
      label = f.file.name;
    } else {
      label = f.name;
    }
    return label;
  }
  getLabelList(f, fileName) {
    const regNumber = fileName;
    const realFileName = f.meta && f.meta.originalName ? f.meta.originalName : f.file.name;
    return (<div>
      <div style={{ wordBreak: 'break-all' }}>
        {regNumber}
      </div>
      <div
        style={regNumber ? { fontSize: 'x-small', wordBreak: 'break-all' }
          : { wordBreak: 'break-all' }}
      >
        {realFileName}
      </div>
    </div>);
  }

  addFile(files) {
    this.props.addFile(files);
  }

  removeFile() {
    const fileToDelete = this.state.fileToDelete || this.state.fileDeleteConfirmation;
    if (fileToDelete) {
      const idx = this.props.files.indexOf(fileToDelete);
      if (idx != -1) {
        this.props.deleteFile(fileToDelete.get('raw').meta.uuid, idx);
      }
    }
    this.closeDeleteModal();
    this.props.handleFormChanged();
  }
  openFileEdit(file) {
    this.setState({ showModal: true, editMode: true, currentFile: file,
      meta: file.get('raw').meta });
  }

  close() {
    this.setState({ showModal: false, editMode: false, currentFile: undefined, meta: undefined });
  }

  open() {
    this.setState({ showModal: true, editMode: false, currentFile: undefined, meta: undefined });
  }

  closeDeleteModal() {
    this.setState({ showDeleteModal: false, fileToDelete: undefined,
      fileDeleteConfirmation: null, currentFile: null });
  }

  openDeleteModal(fileToDelete) {
    this.setState({ showDeleteModal: true, fileToDelete });
  }

  formEditModal(key) {
    return (
      <div key={key}>
        <Col key={key} md={12} style={{ padding: '10px 0 0 0' }}>
          <Label label="Document name" xs={4}>
            <FormControl
              name="regNumber" id="regNumber" defaultValue={this.state.meta.regNumber}
              onChange={this.changeRegNumber}
            />
          </Label>
        </Col>
      </div>
    );
  }

  formFileRow(key, fileData, editFunc) {
    const f = fileData.get('raw', {}) || {};
    const label = this.getLabelList(f, fileData.get('name'));
    return (!f ? '' :
      <Row
        key={key}
        className={'file-row'}
      >
        <Col xs={10}>
          {f.meta.uuid ?
            <Button
              title="Download"
              id={`${key}_download`}
              bsStyle="link" style={{ padding: 0, whiteSpace: 'normal', textAlign: 'left' }}
              href={`/download/api/${f.meta.uuid}`}
            >
              {label}
            </Button>
            : label}
        </Col>
        <Col
          xs={2} style={{ padding: 0 }}
        >
          {this.props.disabled || (f && f.meta && f.meta.isBulkExpenseFile) ? '' :
            <div>
              <Button
                title="Delete"
                id={`${key}_delete`}
                bsStyle="link" onClick={() => {
                  if (this.props.noModal) {
                    this.setState({ fileDeleteConfirmation: f });
                  } else {
                    this.openDeleteModal(fileData);
                  }
                }} style={{ padding: '5px', float: 'right' }}
              >
                <img className={'trash-icon'} src={trash} alt={'Delete'} title={'Delete'} />
              </Button>
              <Button
                title="Edit"
                id={`${key}_edit`}
                bsStyle="link" onClick={editFunc}
                style={{ padding: '5px', float: 'right' }}
              >
                <img
                  src={pencil} alt={'edit'} title={'edit'} className={'payments-table-small-icon'}
                />
              </Button>
            </div>
          }
        </Col>
      </Row>);
  }

  dropzone(label, currentFileDiv) {
    if (this.props.disabled || (this.props.singleMode && this.props.files.size)) {
      return <div />;
    }
    return (
      <div>
        {label ?
          <Row>
            <Col md={12}><h4>{label}</h4></Col>
          </Row>
          :
          <div />
        }
        <Row>
          {this.state.editMode ? '' :
            <Col md={12}>
              <Dropzone
                style={{ width: '100%', height: this.props.singleMode ? '3em' : '6em',
                  border: '1px dashed lightgrey',
                  color: 'lightgray', display: 'flex', justifyContent: 'center',
                  cursor: 'pointer' }}
                id="files" name="files" onDrop={this.onDrop} multiple={false}
              >
                <span style={{ alignSelf: 'center' }}>Click or drop here to add file</span>
              </Dropzone>
            </Col>
          }
          {currentFileDiv}
        </Row>
      </div>
    );
  }

  editInline(label, key) {
    const buttonStyle = { width: '71', height: '30px', padding: '2px 6px' };
    return (
      <div>
        {label ?
          <Row>
            <Col md={12}><h4>{label}</h4></Col>
          </Row>
          :
          <div />
        }
        <Row>
          <Col key={key} md={12} style={{ padding: '0 15px 0 15px' }}>
            <Label label="Document name" sm={12} style={{ paddingLeft: '0px', height: '20px' }}>
              <FormControl
                sm={12}
                name="regNumber" id="regNumber"
                defaultValue={this.state.meta.regNumber}
                onChange={this.changeRegNumber}
              />
            </Label>
          </Col>
        </Row>
        <div style={{ textAlign: 'right' }}>
          <Button id="close_file" style={buttonStyle} onClick={this.close}>Cancel</Button>
          <Button
            id="save_file" style={buttonStyle} bsStyle="primary" onClick={this.onEdit}
          >
            Save
          </Button>
        </div>
      </div>
    );
  }

  deleteConfirmation() {
    return (
      <div>
        <div style={{ textAlign: 'center', paddingBottom: '15px' }}>
          Are you sure you want to delete this file?
        </div>
        <div style={{ textAlign: 'center', paddingBottom: '15px' }}>
          <Button
            bsStyle="danger"
            onClick={this.removeFile}
          >Yes</Button>
          <Button onClick={this.closeDeleteModal}>No</Button>
        </div>
      </div>
    );
  }

  renderUI(label, files, currentFileDiv) {
    return (
      <div>
        {this.props.noModal ?
          this.dropzone(label, currentFileDiv) :
          <Modal show={this.state.showModal} onHide={this.close} >
            <Modal.Body style={{ paddingBottom: '10px' }}>
              {this.dropzone(label, currentFileDiv)}
            </Modal.Body>
            <Modal.Footer style={{ paddingTop: 0, border: 'none' }}>
              <Button id="close_file" style={{ width: 71 }} onClick={this.close}>Cancel</Button>
              {this.state.editMode ?
                <Button
                  id="save_file" style={{ width: 71 }} bsStyle="primary" onClick={this.onEdit}
                >
                  Save
                </Button>
                : <Button
                  id="add_file" style={{ width: 71 }} bsStyle="primary"
                  onClick={() => this.onSave()}
                >
                  Add
                </Button>
              }
            </Modal.Footer>
          </Modal>
        }
        {files}
      </div>
    );
  }

  render() {
    const files = [];
    const DOMelemId = this.props.label ? this.props.label.replace(/\s+/g, '') : 'files';
    if (this.props.files) {
      this.props.files.forEach((f, idx) =>
        files.push(
          this.formFileRow(`${DOMelemId}_${idx}`, f, () => this.openFileEdit(f)),
        ));
    }

    const currentFileDiv = [];
    let label = '';
    if (this.state.currentFile) {
      currentFileDiv.push(this.formEditModal('currentFile'));
      label = this.getLabel(this.state.currentFile);
    }

    const header = (
      <Row id={DOMelemId} className={'file-row'} style={{ display: 'flex' }}>
        <Col xs={8} style={{ padding: 0 }}>Documents</Col>
        <Col xs={4} style={{ padding: 0 }}>
          {!this.props.disabled && !this.props.noModal ?
            <Button
              id={`add${DOMelemId}`} bsStyle="primary"
              onClick={this.open} style={{ padding: '4px 12px', float: 'right', margin: 2 }}
            >
              Add
            </Button>
            : ''
          }
        </Col>
      </Row>
    );

    let UI = this.renderUI(label, files, currentFileDiv);
    if (this.state.fileDeleteConfirmation) {
      UI = this.deleteConfirmation();
    }
    if (this.props.noModal && this.state.editMode) {
      UI = this.editInline();
    }
    return (
      <Panel
        id={this.props.label} header={header}
        className={`${this.props.noModal ? ' ' : 'deals-add-panel'} documents`}
      >
        <Modal bsSize="small" show={this.state.showDeleteModal} onHide={this.closeDeleteModal} >
          <Modal.Body>
            Are you sure you want to delete this file?
          </Modal.Body>
          <Modal.Footer>
            <Button
              bsStyle="danger"
              onClick={this.removeFile}
            >Yes</Button>
            <Button onClick={this.closeDeleteModal}>No</Button>
          </Modal.Footer>
        </Modal>
        {UI}
      </Panel>
    );
  }
}

Files.propTypes = {
  files: React.PropTypes.object,
  label: React.PropTypes.string,
  labelStyle: React.PropTypes.object,
  type: React.PropTypes.string,
  disabled: React.PropTypes.bool,
  dealType: React.PropTypes.string,
  addFile: React.PropTypes.func,
  updateFile: React.PropTypes.func,
  deleteFile: React.PropTypes.func,
  handleFormChanged: React.PropTypes.func,
  noModal: React.PropTypes.bool,
  deleteConfirmation: React.PropTypes.bool,
  singleMode: React.PropTypes.bool,
  onEditModeSwitch: React.PropTypes.func,
};

Files.defaultProps = {
  singleMode: false,
};


export default connect(
  (state, props) => ({
    files: state.getIn(['data', 'deals', 'files', props.type], new List()),
  }),
  (dispatch, props) => ({
    addFile(files) {
      addFile(dispatch, files, props.type);
    },
    updateFile(file, idx) {
      updateFile(dispatch, file, props.type, idx);
    },
    deleteFile(uuid, idx) {
      deleteFile(dispatch, props.type, uuid, idx);
    },
    handleFormChanged() {
      handleFormChanged(dispatch);
    },
  })
)(Files);
